import { useState } from "react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { formatApiError } from "@/lib/errors";
import { toast } from "sonner";
import { MailWarning, RefreshCw, Loader2 } from "lucide-react";

export default function VerifyEmailGate() {
  const { user, refresh, logout } = useAuth();
  const [sending, setSending] = useState(false);

  const resend = async () => {
    setSending(true);
    try {
      await api.post("/auth/resend-verification");
      toast.success(`Confirmation email sent to ${user.email}`);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="max-w-xl mx-auto px-4 py-16" data-testid="verify-email-gate">
      <div className="tactile-card rounded-md p-8 text-center">
        <MailWarning className="h-10 w-10 text-[#FFC857] mx-auto" />
        <div className="font-mono text-[11px] uppercase tracking-widest text-[#FFC857] mt-4">ONE MORE STEP</div>
        <h1 className="font-display text-3xl sm:text-4xl font-bold tracking-tight mt-2">Confirm your email</h1>
        <p className="text-sm text-[#A0A7B0] mt-3">
          We sent a confirmation link to <b className="text-[#F4F1EA]" data-testid="verify-gate-email">{user.email}</b>. Tap it to unlock your dashboard. Check spam if it's not there within a minute.
        </p>
        <div className="flex flex-col sm:flex-row gap-2 justify-center mt-6">
          <Button onClick={resend} disabled={sending} className="btn-emerald h-10" data-testid="verify-gate-resend">
            {sending ? <Loader2 className="h-4 w-4 animate-spin" /> : "Resend confirmation"}
          </Button>
          <Button variant="outline" onClick={refresh} className="btn-outline-paper h-10" data-testid="verify-gate-check">
            <RefreshCw className="h-4 w-4 mr-1" /> I've confirmed it
          </Button>
        </div>
        <button onClick={logout} className="mt-6 text-xs text-[#606872] hover:text-[#A0A7B0]" data-testid="verify-gate-logout">Wrong email? Sign out and start over</button>
      </div>
    </div>
  );
}
